module.exports = __webpack_public_path__ + "img/step-9.4d53c5d3.jpg";